import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledHeader = styled.h4`
    ${setFontVariant("button", colorsPalettes.bluegrey[600])};

    display: flex;
    align-items: center;
    column-gap: 12px;

    user-select: none;
    cursor: pointer;
`;

export const StyledChevronIcon = styled(SWReactIcons)<{ isExpanded?: boolean }>`
    transform: rotate(${({ isExpanded }) => (isExpanded ? "0deg" : "-90deg")});
    transition: all 0.3s linear;

    & svg path {
        fill: ${colorsPalettes.carbon[300]};
    }
`;
